/* hc-dex-ab.js — Dex lightweight A/B framework (created 2026-09-03). No app, no server.
   How it works:
     1. EXPERIMENTS below lists active tests: {id, variants, weights}. Empty list = no-op.
     2. Each visitor gets a sticky assignment per experiment (cookie xw_exp_<id>, 90 days, 50/50 by default).
     3. The assignment is exposed three ways: body class `xw-exp-<id>-<variant>` (style the variant in hc-dex.css),
        window.XW_EXP[id] (for JS-driven variants), and a GA4 event parameter on EVERY gtag event
        (`exp_<id>` = variant) via gtag('set') — so GA4 explorations can split purchase/add_to_cart by variant.
        A one-time `xw_exp_assign` event is also sent on assignment.
     4. Analysis: GA4 MCP -> ga4_run_report with a customEvent:exp_<id> dimension (register it once in GA4 Admin >
        Custom definitions) or compare the `xw_exp_assign` cohorts; Dex computes lift + significance.
   Add a test: push an object to EXPERIMENTS, add `.xw-exp-<id>-b { ... }` rules to hc-dex.css, stage, verify,
   Dima publishes. Remove the object to end the test (cookies expire on their own).
*/
(function () {
  var EXPERIMENTS = [
    // { id: 'ff_prominence', variants: ['a', 'b'], weights: [0.5, 0.5] }
  ];
  if (!EXPERIMENTS.length) return;
  function getCookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : null; }
  function setCookie(n, v, days) { var d = new Date(); d.setTime(d.getTime() + days * 864e5); document.cookie = n + '=' + encodeURIComponent(v) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax'; }
  function pick(exp) { var r = Math.random(), acc = 0, w = exp.weights || exp.variants.map(function () { return 1 / exp.variants.length; });
    for (var i = 0; i < exp.variants.length; i++) { acc += w[i]; if (r < acc) return exp.variants[i]; } return exp.variants[exp.variants.length - 1]; }
  window.XW_EXP = window.XW_EXP || {};
  var params = {};
  EXPERIMENTS.forEach(function (exp) {
    var key = 'xw_exp_' + exp.id, v = getCookie(key), fresh = false;
    if (!v || exp.variants.indexOf(v) < 0) { v = pick(exp); setCookie(key, v, 90); fresh = true; }
    window.XW_EXP[exp.id] = v;
    document.documentElement.classList.add('xw-exp-' + exp.id + '-' + v);
    params['exp_' + exp.id] = v;
    if (fresh && typeof window.gtag === 'function') { window.gtag('event', 'xw_exp_assign', { experiment: exp.id, variant: v, non_interaction: true }); }
  });
  if (typeof window.gtag === 'function') { window.gtag('set', params); }
  else { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'xw_exp_ready' }, params)); }
})();